var bizError = [];
export default bizError;

//# sourceMappingURL=index.js.map
